import { DEFAULT_PAGE_SIZE } from '../../../figma/Pagination/Pagination';
import { types } from 'mobx-state-tree';

export const FilterModel = types
  .model('FilterModel', {
    page: types.optional(types.number, 1),
    size: types.optional(types.number, DEFAULT_PAGE_SIZE),
    sort: types.maybeNull(types.union(types.string, types.array(types.string))),
    search: types.maybeNull(types.string),
    isUpdateViaQuery: types.optional(types.boolean, true),
    isShowFilterButton: types.optional(types.boolean, false),
    initialed: types.optional(types.boolean, true),
  })
  .actions((self) => ({
    updateFilter(data) {
      self.page = Number(data.page || self.page);
      self.size = Number(data.size || self.size);
    },
    shouldUpdateViaQuery(data) {
      self.isUpdateViaQuery = data;
    },
    updateViaQuery(data) {
      self.page = Number(data.page || self.page);
      if (data.sort) {
        self.sort = data.sort;
      }
      if (data.search) {
        self.search = data.search;
      } else {
        self.search = '';
      }
      self.size = Number(data.size || self.size);
    },
    updateSearch(data) {
      self.search = data;
      self.page = 1;
    },
    updateSize(size) {
      self.size = size;
      self.page = 1;
    },
    updatePage(page) {
      self.page = page;
    },
    updateOrder(data: any) {
      self.sort = data;
      self.page = 1;
    },
    toggleFilterButton() {
      self.isShowFilterButton = !self.isShowFilterButton;
    },
    showFilterButton() {
      self.isShowFilterButton = true;
    },
    hideFilterButton() {
      self.isShowFilterButton = false;
    },

    // please leave these functions alone, contact Duy for more info
    clearFilter() {},
    applyFilter() {},
  }))
  .views((self) => ({
    prepareRequest() {
      const { isUpdateViaQuery, isShowFilterButton, initialed, ...rest } = self;
      return rest;
    },
  }));
